"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Carousel: function() {
        return _index.Carousel;
    },
    carouselClassNames: function() {
        return _index.carouselClassNames;
    },
    renderCarousel_unstable: function() {
        return _index.renderCarousel_unstable;
    },
    useCarouselStyles_unstable: function() {
        return _index.useCarouselStyles_unstable;
    },
    useCarousel_unstable: function() {
        return _index.useCarousel_unstable;
    }
});
const _index = require("./components/Carousel/index");
